export enum TrialEndResult {
  NO_THANKS = 0,
  BUY_COURSE = 1
}
